import theme from '@styles/theme';
export default {
  section: {
    maxWidth: '100%',
    margin: 'auto',
    p: ['48px 0', '48px 0', '64px 0', '64px 0', '116px 0'],
    background: theme.rawColors.lightGrey300
  },
  aboutCollectionContainer: {
    width: '100%',
    maxWidth: '1530px',
    height: 'auto',
    margin: 'auto',
    padding: ['0 16px', '0 16px', '0 24px', '0 24px', '0 40px', '0 40px', '0'],
    boxSizing: 'border-box'
  },
  videoContainer: {
    maxWidth: ['100%', '100%', '100%', '100%', '1530px'],
    height: ['100%'],
    position: 'relative',
    margin: 'auto'
  }
};